var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgResize(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M382.53,353.53c-4.97,0-9,4.03-9,9v11h-11c-4.97,0-9,4.03-9,9s4.03,9,9,9h20c4.97,0,9-4.03,9-9v-20c0-4.97-4.03-9-9-9Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M326.41,373.53h-36.12c-4.97,0-9,4.03-9,9s4.03,9,9,9h36.12c4.97,0,9-4.03,9-9s-4.03-9-9-9Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M254.18,373.53h-28.28V189.01l86.65-86.27v85.12c0,6.08,4.92,11,11,11s11-4.92,11-11V75.77c0-6.08-4.92-11-11-11h-112.09c-6.08,0-11,4.92-11,11s4.92,11,11,11h85.95l-87.72,87.33H26.47v-28.28c0-4.97-4.03-9-9-9s-9,4.03-9,9v36.12c0,.18,.02,.36,.03,.54-.01,.18-.03,.36-.03,.54v199.57c0,4.93,4,8.93,8.93,8.93H216.97c.18,0,.36-.02,.54-.03,.18,.01,.36,.03,.54,.03h36.12c4.97,0,9-4.03,9-9s-4.03-9-9-9Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.47,118.71c4.97,0,9-4.03,9-9v-36.12c0-4.97-4.03-9-9-9s-9,4.03-9,9v36.12c0,4.97,4.03,9,9,9Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.47,46.47c4.97,0,9-4.03,9-9v-11h11c4.97,0,9-4.03,9-9s-4.03-9-9-9H17.47c-4.97,0-9,4.03-9,9v20c0,4.97,4.03,9,9,9Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M145.82,26.47h36.12c4.97,0,9-4.03,9-9s-4.03-9-9-9h-36.12c-4.97,0-9,4.03-9,9s4.03,9,9,9Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M290.29,26.47h36.12c4.97,0,9-4.03,9-9s-4.03-9-9-9h-36.12c-4.97,0-9,4.03-9,9s4.03,9,9,9Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M218.06,26.47h36.12c4.97,0,9-4.03,9-9s-4.03-9-9-9h-36.12c-4.97,0-9,4.03-9,9s4.03,9,9,9Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M73.59,26.47h36.12c4.97,0,9-4.03,9-9s-4.03-9-9-9h-36.12c-4.97,0-9,4.03-9,9s4.03,9,9,9Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M382.53,8.47h-20c-4.97,0-9,4.03-9,9s4.03,9,9,9h11v11c0,4.97,4.03,9,9,9s9-4.03,9-9V17.47c0-4.97-4.03-9-9-9Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M382.53,281.29c-4.97,0-9,4.03-9,9v36.12c0,4.97,4.03,9,9,9s9-4.03,9-9v-36.12c0-4.97-4.03-9-9-9Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M382.53,209.06c-4.97,0-9,4.03-9,9v36.12c0,4.97,4.03,9,9,9s9-4.03,9-9v-36.12c0-4.97-4.03-9-9-9Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M382.53,136.82c-4.97,0-9,4.03-9,9v36.12c0,4.97,4.03,9,9,9s9-4.03,9-9v-36.12c0-4.97-4.03-9-9-9Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M382.53,64.59c-4.97,0-9,4.03-9,9v36.12c0,4.97,4.03,9,9,9s9-4.03,9-9v-36.12c0-4.97-4.03-9-9-9Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResize);
export default __webpack_public_path__ + "static/media/resize.8b79ec95.svg";
export { ForwardRef as ReactComponent };